"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFilterBox = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../../general");
exports.StyledFilterBox = (0, styled_components_1.default)(general_1.Paper) `
  ${({ showFilter }) => {
    return (0, styled_components_1.css) `
      height: calc(100vh - 5rem);
      align-items: flex-start;
      position: fixed;
      top: 5rem;
      right: 0;
      width: 332px;
      z-index: 190;
      overflow-x: hidden;
      overflow-y: auto;
      padding-top: 128px;
      transition: all 0.32s ease-in-out;

      & div[aria-label='text-field-wrapper'] {
        margin-bottom: -32px;
      }

      @media (max-width: 883px) {
        transform: ${showFilter ? 'translateX(0)' : 'translateX(100%)'};
        width: 100vw;
      }
    `;
}}
`;
//# sourceMappingURL=styles.js.map